/*
 * Comcast CONFIDENTIAL
 *
 * Copyright 2003 - 2017 Comcast Corporation
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Comcast Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Comcast Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is unlawful and strictly forbidden unless prior written permission is obtained
 * from Comcast Corporation.
 */
import { MakeListController } from './makeList-controller';
var dependencies = ['comcast-addelivery-constants', 'comcast.common.authentication', 'comcast.common.communication', 'comcast.common.navigation', 'comcast.common.notification', 'comcast.orders', 'ngCookies', 'ngMaterial', 'ngMessages', 'ui.grid', 'ui.grid.pagination', 'ui.grid.selection', 'ui.router'];
var defaultName = angular.module('comcast.makelist', dependencies).config(['$stateProvider', 'addelivery.state.constants', '$mdInkRippleProvider', function ($stateProvider, stateConstants, $mdInkRippleProvider) {
  $stateProvider.state('makelist', {
    url: '/makelist',
    views: {
      mainNav: stateConstants.mainNav,
      leftNav: stateConstants.leftNav,
      content: {
        template: require('./makeList-template.html'),
        controller: MakeListController,
        controllerAs: 'vm'
      }
    },
    access: {
      requiresLogin: true,
      requiredPermissions: ['User'],
      permissionCheckType: 'AtLeastOne'
    }
  });
  $mdInkRippleProvider.disableInkRipple();
}]).run(['$rootScope', '$location', 'loginService', function ($rootScope, $location, loginService) {
  $rootScope.$on('$stateChangeStart', function (event, next) {
    var makeListPermission = ['distributionorder.modify'];
    var hasPermission = loginService.hasPermission(makeListPermission);

    if ($location.url() == '/makelist' && !hasPermission) {
      $location.path('/');
    }
  });
}]).name;
export { defaultName as default, dependencies };